import React from "react";

const HubFilters = ({
  modeFilter,
  setModeFilter,
  sharedReviewersCount = 0,
  searchQuery,
  setSearchQuery,
  onOpenHistory,
}) => {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
      {/* Mode Filters */}
      <div className="flex items-center gap-1.5 p-1 bg-gray-50 rounded-xl border border-gray-100 shrink-0 overflow-x-auto">
        <button
          type="button"
          onClick={() => setModeFilter("all")}
          className={`px-3.5 py-1.5 rounded-lg text-xs font-bold transition whitespace-nowrap ${
            modeFilter === "all"
              ? "bg-white text-blue-600 shadow-sm"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          All ({sharedReviewersCount})
        </button>
        <button
          type="button"
          onClick={() => setModeFilter("quiz")}
          className={`px-3.5 py-1.5 rounded-lg text-xs font-bold transition whitespace-nowrap ${
            modeFilter === "quiz"
              ? "bg-white text-blue-600 shadow-sm"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          <i className="fa-solid fa-bolt text-[10px] mr-1"></i> Quizzes
        </button>
        <button
          type="button"
          onClick={() => setModeFilter("cards")}
          className={`px-3.5 py-1.5 rounded-lg text-xs font-bold transition whitespace-nowrap ${
            modeFilter === "cards"
              ? "bg-white text-blue-600 shadow-sm"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          <i className="fa-solid fa-layer-group text-[10px] mr-1"></i> Flashcards
        </button>
        <button
          type="button"
          onClick={() => setModeFilter("summary")}
          className={`px-3.5 py-1.5 rounded-lg text-xs font-bold transition whitespace-nowrap ${
            modeFilter === "summary"
              ? "bg-white text-blue-600 shadow-sm"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          <i className="fa-solid fa-align-left text-[10px] mr-1"></i> Summaries
        </button>
      </div>

      {/* Right Controls: Hall of Fame & Search Bar */}
      <div className="flex items-center gap-2 flex-1 sm:justify-end">
        {onOpenHistory && (
          <button
            type="button"
            onClick={onOpenHistory}
            className="px-3.5 py-2 rounded-xl text-xs font-bold text-indigo-700 bg-indigo-50/80 hover:bg-indigo-100 border border-indigo-100 transition whitespace-nowrap flex items-center gap-1.5 shadow-2xs"
            title="View past challenge results and podium champions"
          >
            <i className="fa-solid fa-trophy text-amber-500 text-xs"></i>
            <span>Hall of Fame</span>
          </button>
        )}

        <div className="relative flex-1 sm:max-w-xs">
          <i className="fa-solid fa-magnifying-glass absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search shared reviewers..."
            className="w-full pl-9 pr-8 py-2 rounded-xl text-xs bg-gray-50 border border-gray-200 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition font-medium text-gray-800"
          />
          {searchQuery && (
            <button
              type="button"
              onClick={() => setSearchQuery("")}
              className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HubFilters;
